<ion-button class="like-button" color="primary" (click)="onLikeClicked()" [disabled]="likeButton">
	<ion-icon slot="icon-only" name="thumbs-up"></ion-icon>
</ion-button>

<ion-button class="dislike-button" color="error" (click)="onDislikeClicked()" [disabled]="dislikeButton">
	<ion-icon slot="icon-only" name="thumbs-down"></ion-icon>
</ion-button>